import { getDomainNotificationManager } from '@repo/core'
import { takeEvery } from 'redux-saga/effects'
import {
  consolidatedPortfolioActions,
  consolidatedPortfolioDownloadActions,
  globalPositionActions,
  globalPositionDownloadActions,
} from '../../store/actions'
import { httpStatusErrorCodesMapper } from './httpStatusErrorCodesMapper'

export function* watchPositionNotifications() {
  yield takeEvery(
    [
      globalPositionActions.getResponse.type,
      globalPositionActions.refreshResponse.type,
      globalPositionDownloadActions.downloadResponse.type,
      consolidatedPortfolioActions.getResponse.type,
      consolidatedPortfolioActions.refreshResponse.type,
      consolidatedPortfolioDownloadActions.downloadResponse.type,
    ],
    getDomainNotificationManager({ domain: 'position', httpStatusErrorCodesMapper }),
  )
}
